import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
`;
const RoomItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${(props)=>props.isActive ? '#f0f0f0' : 'transparent'};
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:active {
    background-color: #e8e8e8;
  }
`;
const RoomInfo = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 8px;
`;
const RoomName = styled.div`
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
`;
const LastMessage = styled.div`
  font-size: 14px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const UnreadBadge = styled.span`
  background-color: #007bff;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
  min-width: 20px;
  text-align: center;
`;
const OnlineIndicator = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props)=>props.isOnline ? '#28a745' : '#ccc'};
  flex-shrink: 0;
`;
const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #666;
`;
const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
`;
/**
 * ChatList Component
 * Displays a list of chat rooms with unread counts and online indicators
 */ export const ChatList = ({ rooms, onSelectRoom, selectedRoomId, loading = false })=>{
    if (loading) {
        return /*#__PURE__*/ _jsx(LoadingState, {
            "data-testid": "chat-list-loading",
            children: "Loading rooms..."
        });
    }
    if (!rooms || rooms.length === 0) {
        return /*#__PURE__*/ _jsxs(EmptyState, {
            "data-testid": "chat-list-empty",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: "No chat rooms available"
                }),
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        fontSize: '14px',
                        marginTop: '8px'
                    },
                    children: "Start a new conversation to get started"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Container, {
        "data-testid": "chat-list",
        children: rooms.map((room, index)=>/*#__PURE__*/ _jsxs(RoomItem, {
                isActive: selectedRoomId === room.roomId,
                onClick: ()=>onSelectRoom(room.roomId),
                "data-testid": `chat-room-item-${index}`,
                children: [
                    /*#__PURE__*/ _jsx(OnlineIndicator, {
                        isOnline: true,
                        "data-testid": `chat-room-online-${index}`
                    }),
                    /*#__PURE__*/ _jsxs(RoomInfo, {
                        children: [
                            /*#__PURE__*/ _jsx(RoomName, {
                                "data-testid": `chat-room-name-${index}`,
                                children: room.roomId ? `Room ${room.roomId.slice(0, 8)}` : `Room ${index}`
                            }),
                            /*#__PURE__*/ _jsx(LastMessage, {
                                "data-testid": `chat-room-last-message-${index}`,
                                children: room.lastMessage || 'No messages yet'
                            })
                        ]
                    }),
                    room.unreadCount && room.unreadCount > 0 && /*#__PURE__*/ _jsx(UnreadBadge, {
                        "data-testid": `chat-room-unread-${index}`,
                        children: room.unreadCount > 99 ? '99+' : room.unreadCount
                    })
                ]
            }, room.roomId || index))
    });
};
